var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSizeSmallSelected = function SvgSizeSmallSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCE0E6",
    d: "M.5.5h99v99H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 15h78v10H11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DACFF",
    d: "M16 18h68v4H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 30h78v10H11zM11 45h78v10H11zM11 60h78v10H11zM11 75h78v10H11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4DACFF",
    d: "M16 33h68v4H16zM16 48h68v4H16zM16 63h68v4H16zM16 78h68v4H16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4DACFF",
    d: "M.5.5h99v99H.5z"
  })));
};
export { SvgSizeSmallSelected as ReactComponent };
export default __webpack_public_path__ + "img/size-small-selected.2d2c6a720d6c919b47a0d4232188ae65.svg";